import React, { Fragment, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import { Typography } from "@material-ui/core";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import { compose } from "recompose";
import { searchQuestions } from "../../../redux/actions";
import { questionsSearchTermSelector } from "../../../redux/selectors";
import {
  debounceMilliseconds,
  minimumSearchCharacters,
} from "../../../utilities/constants";
import { useConstant } from "../../../utilities/useConstant";
var debounce = require("lodash/debounce");

const SearchBar = ({ intl, onSearchChange, questionFilter }) => {
  const dispatch = useDispatch();
  const [filter, setCurrentFilter] = useState(0);

  useEffect(() => {
    setCurrentFilter(questionFilter);
    onSearchChange(questionFilter);
  }, []);

  const onChange = (e) => {
    setCurrentFilter(e.target.value);
    OnSearchChanged(e.target.value);
  };

  const changeFilter = (value) => {
    if (value && value.length >= minimumSearchCharacters) {
      dispatch(searchQuestions(value));
    }
    if (!value || value.length === 0) {
      dispatch(searchQuestions(""));
    }

    if (onSearchChange) {
      onSearchChange(value);
    }
  };

  const OnSearchChanged = useConstant(() =>
    debounce(changeFilter, debounceMilliseconds, { leading: false }),
  );

  return (
    <div>
      <Fragment style={{ width: "100%" }}>
        <Paper
          style={{ width: "100%", padding: "10px", boxSizing: "border-box" }}
        >
          <InputBase
            fullWidth
            placeholder={intl.formatMessage({
              id: "app.general.searchPlaceholder",
            })}
            startAdornment={
              <div style={{ margin: "2px 10px 0 4px" }}>
                <SearchIcon />
              </div>
            }
            value={filter}
            onChange={onChange}
            style={{ minHeight: "34px", lineHeight: "normal" }}
          />
        </Paper>
        <Typography
          variant="body2"
          style={{
            paddingTop: "4px",
            paddingBottom: "16px",
            textAlign: "left",
          }}
        >
          {intl.formatMessage({ id: "app.questions.search" })}
        </Typography>
      </Fragment>
    </div>
  );
};

const mapStateToProps = (state) => ({
  questionFilter: questionsSearchTermSelector(state),
});

const enhance = compose(connect(mapStateToProps), injectIntl);

export default enhance(SearchBar);
